import { faAdd } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FormInput from "components/FormInput/FormInput";
import { memo } from "react";
import { Form as BootstrapForm, Col, Row } from "react-bootstrap";
import { Check, Form } from "shared/ui";
import Select from "shared/ui/Select/Select";
import { Button } from "ui";
import FormNumericInput from "../../../../components/FormNumericInput/FormNumericInput";
import { JobRelatedExpense } from "features/CostLine";

function TransactionCostLineView({
  idx,
  errors,
  register,
  costTypeOptions,
  costLineData,
  isChildOfSplittedCost,
  dependencies,
  handleCostSplit,
  handleSplittedCostRemoval,
  requestIsEditable,
  uploadedFiles,
  cardFormat,
  vatCodes,
  costSplitIsEnabled,
  validations,
  setValue,
  isRemoving,
  currencyCode,
  isJobRelatedAllowed,
  isCostTypeSelectDisabled,
  isPrivateCostAllowed,
  isJobRelated,
  glCodes,
}) {
  return (
    <>
      {isJobRelatedAllowed ? (
        <JobRelatedExpense
          // @ts-ignore
          costLineData={costLineData}
          disabled={!requestIsEditable}
          costTypeOptions={costTypeOptions}
        />
      ) : null}
      <Row className="mt-3">
        <Select
          inputId={`credit_cards_cost_types-select-${idx}`}
          name="cost_type"
          label="Cost type"
          displayAs={Col}
          options={costTypeOptions}
          isDisabled={isCostTypeSelectDisabled}
          error={errors?.cost_type}
        />

        <FormInput
          name="comment"
          label="Comment"
          as="textarea"
          displayAs={Col}
        />
      </Row>
      {cardFormat === "us/ca" && (
        <Row className="mt-4">
          <FormInput
            name="posting_entity"
            label="Entity"
            displayAs={Col}
            readOnly={!costSplitIsEnabled}
          />
          <FormInput
            name="posting_cost_centre"
            label="Cost Center"
            displayAs={Col}
            readOnly={!costSplitIsEnabled}
          />
          <Col>
            <Select
              name="posting_gl_code"
              label="GL number"
              placeholder="GL - choose option"
              error={errors.posting_gl_code}
              isDisabled={!requestIsEditable}
              options={glCodes}
              readOnly={glCodes.length === 1}
            />
          </Col>
          <FormInput
            name="posting_internal_order"
            label="I/O"
            displayAs={Col}
            readOnly={!costSplitIsEnabled}
          />
        </Row>
      )}
      <Row className="mt-4">
        <Col md="3">
          <FormNumericInput
            name="amount"
            addon={currencyCode}
            label="Gross Amount"
            isAllowed={({ floatValue }) =>
              floatValue === undefined ||
              (floatValue <= 999999999999.99 && floatValue >= -999999999999.99)
            }
            allowNegative={true}
          />
        </Col>
        {cardFormat === "corporate" && (
          <Select
            md={3}
            label="VAT"
            displayAs={Col}
            name="vat"
            isClearable={isJobRelated}
            isDisabled={!requestIsEditable}
            options={vatCodes}
            error={errors?.vat}
          />
        )}
        {cardFormat === "us/ca" && (
          <Col md="6">
            <Form.FilesInput
              label="Attachments"
              name="attachments"
              error={errors?.attachments}
              disabled={!requestIsEditable}
              uploadedFiles={uploadedFiles}
              maxSize={validations?.max_allowed_file_size_in_bytes}
              max={validations?.attachments_count_rules.data?.sub_costs?.max}
              min={validations?.attachments_count_rules.data?.sub_costs?.min}
              acceptedExtensions={validations?.attachments_allowed_file_types}
              setValue={setValue}
            />
          </Col>
        )}
        {isPrivateCostAllowed && (
          <Col>
            <BootstrapForm.Label>Private cost?</BootstrapForm.Label>
            <Check
              feedback="This field is required"
              type="switch"
              name="private_cost"
              register={register}
              label="yes"
              reverseLabel="no"
            />
          </Col>
        )}
      </Row>
      <div className="d-flex">
        {isChildOfSplittedCost && requestIsEditable && (
          <Button
            className="mt-4"
            variant="outline-primary"
            isLoading={isRemoving}
            disabled={isRemoving}
            onClick={handleSplittedCostRemoval}
          >
            Remove splitted cost
          </Button>
        )}

        {costSplitIsEnabled && (
          <div className="mt-4 ms-auto">
            <Button variant="outline-primary" onClick={handleCostSplit}>
              Split cost
              <FontAwesomeIcon icon={faAdd} className="ms-2" />
            </Button>
          </div>
        )}
      </div>
    </>
  );
}

export default memo(TransactionCostLineView);
